type CollapsibleListItem = { key: string; text: string };

// `count` is the number in the title, the number of items unless given
export const CollapsibleList = ({
  title,
  items,
  count = items.length,
  open = false,
}: {
  title: string;
  items: CollapsibleListItem[];
  count?: number;
  open?: boolean;
}) =>
  items.length ? (
    <details className="text-sm" open={open}>
      <summary className="cursor-pointer font-medium">
        {title} ({count.toLocaleString()})
      </summary>
      <ul className="mt-1 max-h-48 overflow-y-auto rounded-md border px-3 py-2 text-muted-foreground">
        {items.map((item) => (
          <li key={item.key}>{item.text}</li>
        ))}
      </ul>
    </details>
  ) : null;
